var _defs, _polygon, _rect, _polygon2, _polygon3, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 144.17 53.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "14.43 9.33 0.52 9.33 0.52 40.66 0.52 53.16 14.43 53.16 29.51 53.16 29.51 40.66 14.43 40.66 14.43 9.33"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 32.82,
    y: 9.33,
    width: 13.91,
    height: 43.83
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "77.86 31.14 63.95 9.33 50.05 9.33 50.05 53.16 63.95 53.16 63.95 31.36 77.86 53.16 91.77 53.16 91.77 9.33 77.86 9.33 77.86 31.14"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "121.33 10.99 121.33 10.99 121.33 11 109.67 29.59 108.99 29.59 108.99 9.33 95.08 9.33 95.08 53.16 108.99 53.16 108.99 34.56 109.04 34.56 120.7 53.16 120.71 53.16 134.8 53.16 132.72 49.84 121.9 32.58 133.36 14.31 135.23 14.31 137.07 10.99 121.33 10.99"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.51,8.27a4.14,4.14,0,1,1,4.14-4.13A4.14,4.14,0,0,1,139.51,8.27Zm0-7.32a3.19,3.19,0,1,0,3.18,3.19A3.19,3.19,0,0,0,139.51,1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.08,6.19V2.25h1.74a1.06,1.06,0,0,1,.5.12,1.28,1.28,0,0,1,.4.29,1.45,1.45,0,0,1,.26.43,1.27,1.27,0,0,1,.09.47,1.29,1.29,0,0,1-.19.7,1.08,1.08,0,0,1-.52.45l.9,1.48h-.86l-.8-1.32h-.76V6.19Zm.76-2h1a.46.46,0,0,0,.2,0,.52.52,0,0,0,.16-.14.54.54,0,0,0,.1-.2.69.69,0,0,0,0-.25.66.66,0,0,0,0-.25.72.72,0,0,0-.12-.21A.7.7,0,0,0,140,3a.49.49,0,0,0-.2-.05h-.93Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4511bbe5ffe5b1117b38306b0dcf03be.svg";
export { ForwardRef as ReactComponent };